/**
 * Normalizes API bodies that represent a list (SRP: one place for list-shaped responses).
 * Accepts axios `response.data` when the server returns:
 * - T[]
 * - { success?: boolean, data: T[] }
 * - { data: T[] }
 */
export function normalizeApiListResponse(rawData) {
  if (!rawData) return [];
  if (Array.isArray(rawData)) return rawData;
  if (rawData.success && Array.isArray(rawData.data)) return rawData.data;
  if (Array.isArray(rawData.data)) return rawData.data;
  return [];
}
